/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react'
import { Grid, Typography } from '@mui/material'
import { useSnackbar } from 'notistack'
import { RainbowBorderButton } from 'src/components/shared/atoms'
import {
  useGetTopicsListQuery,
  useUserTopicsMutation,
} from 'src/store/ApiCall/topicsAPI'
import { CrossIcon } from 'src/assets/svgs'
import useStyles from './styles'
import { getCookie } from 'cookies-next'

interface TopicsPopupType {
  closeHandler: () => void
  userData: { id: number; username: string }
}

const TopicsPopup: React.FC<TopicsPopupType> = ({
  closeHandler,
  userData,
}: TopicsPopupType) => {
  const { enqueueSnackbar } = useSnackbar()
  const [topicsList, setTopicsList] = React.useState<any>([])
  const isBrowser = typeof window === 'object' ? true : false
  const lang = getCookie('lang')
  const [loggedInUser, setLoggedInUser] = React.useState({
    id: -1,
    username: '',
    avatar: '',
  })
  React.useEffect(() => {
    if (window) {
      const loggedInUserJSON =
        typeof window === 'object' ? localStorage.getItem('dtl_token') : null

      if (loggedInUserJSON) {
        setLoggedInUser(JSON.parse(loggedInUserJSON))
      }
    }
  }, [])
  const [selectedTopics, setSelectedTopics] = React.useState<
    { id: number | string; topic: string }[]
  >([])
  const { classes } = useStyles()

  const { data, error } = useGetTopicsListQuery()
  const [userTopics] = useUserTopicsMutation()

  React.useEffect(() => {
    if (data && data.data.length > 0) {
      setTopicsList(data.data)
      return
    }
  }, [data])

  const topicButtonHandler = (topic: {
    id: number | string
    topic: string
  }): void => {
    // console.log('topics: ', topic)
    const isObjectExist = selectedTopics.some((item) => item.id === topic.id)

    if (isObjectExist) {
      const filteredArray = selectedTopics.filter(
        (item) => item.id !== topic.id
      )
      setSelectedTopics(filteredArray)
      // console.log('topics mapped: ', filteredArray)
    } else {
      setSelectedTopics([...selectedTopics, topic])
    }
  }

  const checkInclusion = (topic: {
    id: number | string
    topic: string
  }): boolean => {
    const isObjectExist = selectedTopics.some((item) => item.id === topic.id)

    if (isObjectExist) {
      return true
    }

    return false
  }

  const topicSubmitHandler = async () => {
    const res = await userTopics({
      data: {
        email: {
          id: userData.id, // TODO: replace with localStorage user obj id
          attributes: {
            username: userData.username, // TODO: replace with localStorage user obj email
          },
        },
        topics: selectedTopics.map((item) => {
          return { id: item.id, topic: item.topic }
        }),
      },
    })

    if (res && userData) {
      localStorage.setItem(
        'dtl_token',
        JSON.stringify({
          ...loggedInUser,
          topics: true,
        })
      )
      closeHandler()
    }
  }

  if (error) {
    enqueueSnackbar('Error fetching topics! Please try later', {
      variant: 'error',
    })
    return (
      <Grid container className={classes.root}>
        <Grid container item className={classes.innerContainer}></Grid>
      </Grid>
    )
  }

  return (
    <Grid container className={classes.root}>
      <Grid item className={classes.closeIcon} onClick={closeHandler}>
        <CrossIcon />
      </Grid>
      <Grid container item className={classes.innerContainer}>
        <Grid item md={12} className={classes.textContainer}>
          <Typography variant="h2" className={classes.heading}>
            {isBrowser && lang === 'En' ? 'SELECT TOPICS' : 'SELECCIONE TEMAS'}
          </Typography>
          <Typography variant="body2" className={classes.subHeading}>
            {isBrowser && lang === 'En'
              ? 'Discover content that matches your interests with just a few clicks! Our AI will quickly gather your favourite topics and provide you with tailored recommendations that are perfect for you.'
              : '¡Descubre contenido que coincida con tus intereses con solo unos pocos clics! Nuestra IA reunirá rápidamente sus temas favoritos y le brindará con recomendaciones personalizadas que son perfectas para usted.'}
          </Typography>
        </Grid>
        <Grid item md={12} className={classes.topicBtnContainer}>
          {topicsList?.map((item: any, idx: number) => {
            if (item.attributes.topic === 'all') return ''
            return (
              <RainbowBorderButton
                text={item.attributes.topic}
                key={idx}
                className={classes.topicButton}
                active={checkInclusion({
                  id: item.id,
                  topic: item.attributes.topic,
                })}
                onClick={() =>
                  topicButtonHandler({
                    id: item.id,
                    topic: item.attributes.topic,
                  })
                }
              />
            )
          })}
        </Grid>
        <Grid item md={12} className={classes.continueBtnContainer}>
          <button className={classes.continueBtn} onClick={topicSubmitHandler}>
            CONTINUE
          </button>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default TopicsPopup
